unit UReportForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, UMainConfig,
  Vcl.Imaging.pngimage, Vcl.Controls, WEBLib.ExtCtrls, WEBLib.ComCtrls,
  UWebReportUtils, WEBLib.Buttons, Types, Vcl.Grids, WEBLib.Grids;

type
  TReportForm = class(TForm)
    pnlHeader: TPanel;
    imgLogo: TImageControl;
    lblHeader: TLabel;
    btnBack: TImageControl;
    pnlFooter: TPanel;
    pcMain: TPageControl;
    tsRepHead: TTabSheet;
    tsRepItems: TTabSheet;
    tsView: TTabSheet;
    htmlContainer: THTMLContainer;
    pnlSign: TPanel;
    pnlPbButtons: TPanel;
    WebLabel1: TLabel;
    btnPbClear: TButton;
    btnPbSign: TButton;
    pbSign: TPaintBox;
    pnlViewButtons: TPanel;
    btnSign: TBitBtn;
    btnCreatePdf: TBitBtn;
    btnMail: TBitBtn;
    pnlButtons: TPanel;
    btnAppendPicture: TBitBtn;
    btnEdit: TBitBtn;
    btnDelete: TBitBtn;
    btnUp: TBitBtn;
    btnDown: TBitBtn;
    sgReportItemList: TStringGrid;
    btnAppendNotice: TBitBtn;
    btnAppendMaterial: TBitBtn;
    btnAppendItem: TBitBtn;
    pnlRepHead: TPanel;
    dtpRepVom: TDateTimePicker;
    lblAuftrag: TLabel;
    lblAuftrag1: TLabel;
    lblRepVom: TLabel;
    lblUser: TLabel;
    procedure WebFormResize(Sender: TObject);
    procedure btnBackClick(Sender: TObject);
    procedure tsViewShow(Sender: TObject);
    procedure dtpRepVomChange(Sender: TObject);
    [Async]
    procedure btnAppendPictureClick(Sender: TObject); async;
    procedure tsRepItemsShow(Sender: TObject);
    procedure btnDeleteClick(Sender: TObject);
    procedure sgReportItemListSelectCell(Sender: TObject; ACol, ARow: Integer;
      var CanSelect: Boolean);
    [Async]
    procedure btnAppendNoticeClick(Sender: TObject); async;
    [Async]
    procedure btnAppendMaterialClick(Sender: TObject); async;
    procedure btnUpClick(Sender: TObject);
    procedure btnDownClick(Sender: TObject);
    [Async]
    procedure btnAppendItemClick(Sender: TObject); async;
    [Async]
    procedure btnEditClick(Sender: TObject); async;
    procedure btnSignClick(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure pbSignMouseDown(Sender: TObject; Button: TMouseButton;
      Shift: TShiftState; X, Y: Integer);
    procedure pbSignMouseUp(Sender: TObject; Button: TMouseButton;
      Shift: TShiftState; X, Y: Integer);
    procedure pbSignMouseMove(Sender: TObject; Shift: TShiftState;
      X, Y: Integer);
    procedure pbSignMouseLeave(Sender: TObject);
    procedure btnPbClearClick(Sender: TObject);
    procedure btnPbSignClick(Sender: TObject);
    procedure btnCreatePdfClick(Sender: TObject);
    procedure btnMailClick(Sender: TObject);
    procedure tsRepHeadShow(Sender: TObject);
    procedure WebFormOrientationChange(Sender: TObject;
      AOrientation: TScreenOrientation);
  private
    FMouseDown: Boolean;
    FCreatePdf: Boolean;
    FMainConfig: TMainConfig;
    FReport: TReport;
    procedure HandleHtmlReady(Sender: TObject; AHtml: string);
    procedure HandleSign(Sender: TObject; ABase64: string);
    procedure SetMask;
    procedure SetMainConfig(const Value: TMainConfig);
    procedure SetReport(const Value: TReport);
  public
    procedure EnableButtons(Value: Boolean);
    procedure HandleListError(Sender: TObject; AMsg: string);
    procedure HandlePropertyChanged(Sender: TObject; PropertyName: string);
    procedure sgReportItemListFill(Sender: TObject);
    property MainConfig: TMainConfig read FMainConfig write SetMainConfig;
    property Report: TReport read FReport write SetReport;
  protected procedure LoadDFMValues; override; end;

var
  ReportForm: TReportForm;

implementation

uses
  UEssentialHelper, UAttachmentListForm, UAttachmentModel, UMaterialListForm,
  UVmPosModel, UReportItemForm, UWebHtml2Pdf, WEBLib.LocalFiles, WEBLib.Utils,
  Math;

{$R *.dfm}
{ TReportForm }

procedure TReportForm.btnAppendItemClick(Sender: TObject);
var
  frm: TReportItemForm;
begin
  Self.MainConfig.TimerReset;
  frm := TReportItemForm.Create(Self);
  frm.Caption := Self.Caption;
  frm.Popup := false;
  await(TReportItemForm, frm.Load);
  frm.Item := TReportItem.Create;
  frm.MainConfig := Self.MainConfig;
  try
    Self.Hide;
    if await(TModalresult, frm.Execute) = mrOK then
    begin
      Self.Report.ReportItemList.Add(frm.Item);
    end;
  finally
    Self.Show;
    frm.Free;
  end;
end;

procedure TReportForm.btnAppendMaterialClick(Sender: TObject);
var
  frm: TMaterialListForm;
  Item: TReportItem;
  index, i, c: Integer;
  vItem: TVmPosModel;
  aItem: TReportArtItem;
begin
  Self.MainConfig.TimerReset;
  frm := TMaterialListForm.Create(Self);
  frm.Caption := Self.Caption;
  frm.Popup := false;
  await(TMaterialListForm, frm.Load);
  frm.Fak := Self.Report.Fak;
  frm.ReportMode := true;
  frm.MainConfig := Self.MainConfig;
  try
    Self.Hide;
    if await(TModalresult, frm.Execute) = mrOK then
    begin
      Item := TReportItem.Create;
      Item.Kind := ikHeading;
      Item.Bezeichnung := 'Verbrauchsmaterial';
      index := Self.Report.ReportItemList.IndexOf(Item);
      if index = -1 then
      begin
        Item.SubItem := TReportHeading.Create;
        with Item.SubItem as TReportHeading do
        begin
          Size := '4';
          Align := 'links';
          Content := 'Verbrauchsmaterial';
        end;
        Self.Report.ReportItemList.Add(Item);
      end;
      Item := TReportItem.Create;
      Item.Kind := ikArtList;
      Item.Bezeichnung := 'Liste Material';
      index := Self.Report.ReportItemList.IndexOf(Item);
      if index >= 0 then
        Item := Self.Report.ReportItemList.Items[index]
      else
        Item.SubItem := TReportArtList.Create;
      with Item.SubItem as TReportArtList do
      begin
        c := Count;
        for i := 0 to frm.VmPosList.Count - 1 do
        begin
          vItem := frm.VmPosList.Items[i];
          if vItem.Selected then
          begin
            Inc(c);
            Count := c;
            aItem := GetItem(c - 1);
            aItem.ArtNr := vItem.Mat.ArtNr;
            aItem.Menge := vItem.Menge;
            aItem.Einheit := vItem.Mat.MeEinheit;
            aItem.Bezeichnung := vItem.Mat.Bezeichnung;
          end;
        end;
      end;
      if index = -1 then
        Self.Report.ReportItemList.Add(Item);
    end;
  finally
    Self.Show;
    frm.Free;
  end;
end;

procedure TReportForm.btnAppendNoticeClick(Sender: TObject);
var
  frm: TAttachmentListForm;
  Item: TReportItem;
  index, i: Integer;
  aItem: TAttachmentModel;
begin
  Self.MainConfig.TimerReset;
  frm := TAttachmentListForm.Create(Self);
  frm.Caption := Self.Caption;
  frm.Popup := false;
  await(TAttachmentListForm, frm.Load);
  frm.MainConfig := Self.MainConfig;
  frm.Kind := akComment;
  frm.FakNr := Self.Report.Fak.Nr;
  frm.pnlButtons.Visible := false;
  try
    Self.Hide;
    if await(TModalresult, frm.Execute) = mrOK then
    begin
      Item := TReportItem.Create;
      Item.Kind := ikHeading;
      Item.Bezeichnung := 'Notizen';
      index := Self.Report.ReportItemList.IndexOf(Item);
      if index = -1 then
      begin
        Item.SubItem := TReportHeading.Create;
        with Item.SubItem as TReportHeading do
        begin
          Size := '4';
          Align := 'links';
          Content := 'Notizen, Kommentare und Infos';
        end;
        Self.Report.ReportItemList.Add(Item);
      end;
      for i := 0 to frm.AttachmentList.Count - 1 do
      begin
        aItem := frm.AttachmentList.Items[i];
        if aItem.Selected then
        begin
          Item := TReportItem.Create;
          Item.Bezeichnung := 'Notiz_' + aItem.Filename;
          Item.Kind := ikComment;
          Item.SubItem := TReportComment.Create;
          with Item.SubItem as TReportComment do
          begin
            Filename := aItem.Filename;
            Pathname := aItem.FakNr + '\Comments';
          end;
          Self.Report.ReportItemList.Add(Item);
        end;
      end;
    end;
  finally
    frm.Hide;
    Self.Show;
    frm.Free;
  end;
end;

procedure TReportForm.btnAppendPictureClick(Sender: TObject);
var
  frm: TAttachmentListForm;
  Item: TReportItem;
  index, i: Integer;
  aItem: TAttachmentModel;
begin
  Self.MainConfig.TimerReset;
  frm := TAttachmentListForm.Create(Self);
  frm.Caption := Self.Caption;
  frm.Popup := false;
  await(TAttachmentListForm, frm.Load);
  frm.MainConfig := Self.MainConfig;
  frm.Kind := akPicture;
  frm.FakNr := Self.Report.Fak.Nr;
  frm.pnlButtons.Visible := false;
  try
    Self.Hide;
    if await(TModalresult, frm.Execute) = mrOK then
    begin
      Item := TReportItem.Create;
      Item.Kind := ikHeading;
      Item.Bezeichnung := 'Bildergalerie';
      index := Self.Report.ReportItemList.IndexOf(Item);
      if index = -1 then
      begin
        Item.SubItem := TReportHeading.Create;
        with Item.SubItem as TReportHeading do
        begin
          Size := '4';
          Align := 'links';
          Content := 'Bildergalerie';
        end;
        Self.Report.ReportItemList.Add(Item);
      end;
      for i := 0 to frm.AttachmentList.Count - 1 do
      begin
        aItem := frm.AttachmentList.Items[i];
        if aItem.Selected then
        begin
          Item := TReportItem.Create;
          Item.Bezeichnung := 'Bild_' + aItem.Filename;
          Item.Kind := ikImage;
          Item.SubItem := TReportImage.Create;
          with Item.SubItem as TReportImage do
          begin
            Filename := aItem.Filename;
            Pathname := aItem.FakNr + '\Pictures';
            if aItem.Vorname <> '' then
              Legend := 'Erstellt von ' + aItem.Vorname + ' ' + aItem.Name +
                ' am ' + FormatDateTime('ddd dd.mm.yyyy hh:nn', aItem.CreatedAt)
            else
              Legend := 'Erstellt von ' + aItem.Name + ' am ' +
                FormatDateTime('ddd dd.mm.yyyy hh:nn', aItem.CreatedAt);
          end;
          Self.Report.ReportItemList.Add(Item);
        end;
      end;
    end;
  finally
    frm.Hide;
    Self.Show;
    frm.Free;
  end;
end;

procedure TReportForm.btnBackClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.Close;
end;

procedure TReportForm.btnCreatePdfClick(Sender: TObject);
var
  html2Pdf: THtml2Pdf;
  procedure HandleData(Sender: TObject; ABase64: string);
  var
    p: Integer;
    bFile: TBinaryFile;
    procedure HandleFileSave(Sender: TObject);
    var
      tFile: TTextFile;
      p, f: string;
      procedure HandleTextFileSave(Sender: TObject);
      begin
        Self.Report.PdfPathname := p;
        Self.Report.PdfFilename := f;
      end;

      procedure HandleFileExists(Sender: TObject; AValue: Boolean);
      begin
        if not AValue then
        begin
          tFile.Text := ABase64;
          tFile.OnFileSave := HandleTextFileSave;
          tFile.SaveAsFile(p, f);
        end;
      end;

    begin
      f := Self.Report.Name;
      Delete(f, 1, 1);
      Delete(f, Length(f), 1);
      f := f + '.pdf';
      p := Self.Report.Fak.Nr + '\Pdfs';
      tFile := TTextFile.Create;
      tFile.OnFileExists := HandleFileExists;
      tFile.FileExists(p, f)
    end;

  begin
    p := Pos('base64,', ABase64);
    if p > 0 then
      Delete(ABase64, 1, p + Length('base64,') - 1);
    bFile := TBinaryFile.Create(Self);
    bFile.Data := Base64ToArrayBuffer(ABase64);
    bFile.OnFileSave := HandleFileSave;
    bFile.SaveAsFile;
  end;

begin
  Self.MainConfig.TimerReset;
  html2Pdf := THtml2Pdf.Create;
  html2Pdf.OnGetData := HandleData;
  html2Pdf.HtmlDiv := htmlContainer.HTML.Text;
  html2Pdf.CreatePdf;
end;

procedure TReportForm.btnDeleteClick(Sender: TObject);
var
  s: string;
  procedure HandleResult(Result: TModalresult);
  var
    i: Integer;
  begin
    if Result = mrYes then
    begin
      i := Self.Report.ReportItemList.IndexOf
        (Self.Report.ReportItemList.SelectedItem);
      if i >= 0 then
      begin
        Self.Report.ReportItemList.Delete(i);
        Self.Report.ReportItemList.SelectedItem := nil;
      end;
    end;
  end;

begin
  Self.MainConfig.TimerReset;
  s := 'Möchten Sie den Eintrag'#13#10;
  s := s + Self.Report.ReportItemList.SelectedItem.ToString + #13#10;
  s := s + 'jetzt löschen?';
  MessageDLG(s, mtConfirmation, [mbYes, mbNo], @HandleResult);
end;

procedure TReportForm.btnDownClick(Sender: TObject);
var
  i: Integer;
begin
  Self.MainConfig.TimerReset;
  i := Self.Report.ReportItemList.IndexOf
    (Self.Report.ReportItemList.SelectedItem);
  if i < Self.Report.ReportItemList.Count - 1 then
  begin
    Self.Report.ReportItemList.Move(i, i + 1);
    sgReportItemList.Row := i + 2;
  end;
end;

procedure TReportForm.btnEditClick(Sender: TObject);
var
  frm: TReportItemForm;
begin
  Self.MainConfig.TimerReset;
  frm := TReportItemForm.Create(Self);
  frm.Caption := Self.Caption;
  frm.Popup := false;
  await(TReportItemForm, frm.Load);
  frm.Item := Self.Report.ReportItemList.SelectedItem;
  frm.MainConfig := Self.MainConfig;
  try
    Self.Hide;
    if await(TModalresult, frm.Execute) = mrOK then
      Self.sgReportItemListFill(Sender);
  finally
    Self.Show;
    frm.Free;
  end;
end;

procedure TReportForm.btnMailClick(Sender: TObject);
var
  empf, betreff, txt: string;
begin
  Self.MainConfig.TimerReset;
  empf := '';
  betreff := Self.Report.Fak.ToStringV1;
  txt := 'siehe Anlage';
  asm
    function sendMail(e, b, t) {
    e = encodeURIComponent(e);
    b = encodeURIComponent(b);
    t = encodeURIComponent(t);
    const mailtoLink = 'mailto:' + e + '?subject=' + b + '&body=' + t;
    window.location.href = mailtoLink;
     };
    sendMail(empf, betreff, txt);
  end;
end;

procedure TReportForm.btnPbClearClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  pbSign.Canvas.FillRect(pbSign.ClientRect);
end;

procedure TReportForm.btnPbSignClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.HandleSign(Sender, pbSign.Canvas.GetBase64Image);
end;

procedure TReportForm.btnSignClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  pnlSign.Visible := not pnlSign.Visible;
  pbSign.Canvas.FillRect(pbSign.ClientRect);
end;

procedure TReportForm.btnUpClick(Sender: TObject);
var
  i: Integer;
begin
  Self.MainConfig.TimerReset;
  i := Self.Report.ReportItemList.IndexOf
    (Self.Report.ReportItemList.SelectedItem);
  if i > 0 then
  begin
    Self.Report.ReportItemList.Move(i, i - 1);
    sgReportItemList.Row := i;
  end;
end;

procedure TReportForm.dtpRepVomChange(Sender: TObject);
begin
  Self.Report.Datum := dtpRepVom.Date;
end;

procedure TReportForm.EnableButtons(Value: Boolean);
begin
  if Value and (Self.Report.ReportItemList.SelectedItem <> nil) then
    btnEdit.Visible := Self.Report.ReportItemList.SelectedItem.Kind
      in [ikHeading, ikParagraph]
  else
    btnEdit.Visible := false;
  btnDelete.Visible := Value and
    (Self.Report.ReportItemList.SelectedItem <> nil);
  btnUp.Visible := Value and (Self.Report.ReportItemList.SelectedItem <> nil);
  btnDown.Visible := Value and (Self.Report.ReportItemList.SelectedItem <> nil);
end;

procedure TReportForm.HandleHtmlReady(Sender: TObject; AHtml: string);
var
  html2Pdf: THtml2Pdf;
  procedure HandleGetData(Sender: TObject; ABase64: string);
  var
    tFile: TTextFile;
    p, f: string;
    i: Integer;
    procedure HandleFileSave(Sender: TObject);
    begin
      Self.Report.PdfPathname := p;
      Self.Report.PdfFilename := f;
      FCreatePdf := false;
      Self.btnBackClick(Self);
    end;

  begin
    tFile := TTextFile.Create(nil);
    i := Pos('base64,', ABase64);
    if i > 0 then
      Delete(ABase64, 1, i + Length('base64,') - 1);
    tFile.Text := ABase64;
    tFile.OnFileSave := HandleFileSave;
    f := Self.Report.Name;
    Delete(f, 1, 1);
    Delete(f, Length(f), 1);
    f := f + '.pdf';
    p := Self.Report.Fak.Nr + '\Pdfs';
    tFile.SaveAsFile(p, f);
  end;

begin
  htmlContainer.HTML.Text := AHtml;
  if FCreatePdf and not Self.Report.PdfFileExists then
  begin
    html2Pdf := THtml2Pdf.Create;
    html2Pdf.OnGetData := HandleGetData;
    html2Pdf.HtmlDiv := htmlContainer.HTML.Text;
    html2Pdf.CreatePdf;
  end;
end;

procedure TReportForm.HandleListError(Sender: TObject; AMsg: string);
begin
  MessageDLG(AMsg, mtWarning, [mbOK], nil);
end;

procedure TReportForm.HandlePropertyChanged(Sender: TObject;
  PropertyName: string);
begin
  if PropertyName = 'Signed' then
  begin
    pnlButtons.Visible := not Self.Report.ReportItemList.Signed;
    btnSign.Visible := not Self.Report.ReportItemList.Signed;
    if Self.Report.ReportItemList.Signed then
    begin
      dtpRepVom.Visible := false;
      lblRepVom.Caption := 'Bericht vom ' + FormatDateTime('dd.mm.yyyy',
        Self.Report.Datum);
    end
    else
    begin
      dtpRepVom.Visible := true;
      lblRepVom.Caption := 'Bericht vom';
    end;
    btnCreatePdf.Visible := not btnSign.Visible;
    btnMail.Visible := btnCreatePdf.Visible;
  end;
  if PropertyName = 'SelectedItem' then
    Self.EnableButtons(Self.Report.ReportItemList.SelectedItem <> nil);
end;

procedure TReportForm.HandleSign(Sender: TObject; ABase64: string);
var
  Item: TReportItem;
  procedure HandleFileSaveIntern(Sender: TObject);
  begin
    pnlSign.Visible := false;
    Self.Report.ReportItemList.Add(Item);
    Self.Report.ReportItemList.CreateHtml;
  end;

begin
  FCreatePdf := true;
  Item := TReportItem.Create;
  Item.Kind := ikSign;
  Item.Bezeichnung := 'Unterschrift';
  Item.SubItem := TReportSign.Create;
  with Item.SubItem as TReportSign do
  begin
    Pathname := Self.Report.Fak.Nr + '\Signs';
    Filename := 'Sign' + Self.Report.Name + '.png';
    OnFileSave := HandleFileSaveIntern;
    SaveFile(ABase64);
  end;
end;

procedure TReportForm.pbSignMouseDown(Sender: TObject; Button: TMouseButton;
  Shift: TShiftState; X, Y: Integer);
begin
  FMouseDown := true;
  pbSign.Canvas.MoveTo(X, Y);
end;

procedure TReportForm.pbSignMouseLeave(Sender: TObject);
begin
  FMouseDown := false;
end;

procedure TReportForm.pbSignMouseMove(Sender: TObject; Shift: TShiftState;
  X, Y: Integer);
begin
  if FMouseDown then
    pbSign.Canvas.LineTo(X, Y);
end;

procedure TReportForm.pbSignMouseUp(Sender: TObject; Button: TMouseButton;
  Shift: TShiftState; X, Y: Integer);
begin
  FMouseDown := false;
end;

procedure TReportForm.SetMainConfig(const Value: TMainConfig);
begin
  FMainConfig := Value;
  Self.MainConfig.CurrentForm := Self.Name;
  ColorComponents(Self, Self.MainConfig.ColorConfig);
  pnlFooter.Caption := Self.MainConfig.Copyright;
  Self.WebFormResize(Self);
end;

procedure TReportForm.SetMask;
begin
  if Self.Report.ReportItemList.Signed then
  begin
    dtpRepVom.Visible := false;
    lblRepVom.Caption := 'Bericht vom ' + FormatDateTime('dd.mm.yyyy',
      Self.Report.Datum);
  end
  else
  begin
    dtpRepVom.Visible := true;
    lblRepVom.Caption := 'Bericht vom';
    dtpRepVom.DateTime := Self.Report.Datum;
  end;
  lblUser.Caption := 'erstellt von ' + Self.Report.User.ToString;
  lblAuftrag1.Caption := Self.Report.Fak.ToStringV1;
end;

procedure TReportForm.SetReport(const Value: TReport);
begin
  FReport := Value;
  Self.SetMask;
  pcMain.TabIndex := 0;
end;

procedure TReportForm.sgReportItemListFill(Sender: TObject);
var
  i: Integer;
  Item: TReportItem;
  procedure HandleFileOpen(Sender: TObject; ABase64: string);
  var
    s: string;
  begin
    with Sender as TReportImage do
    begin
      s := FormatBase64(ABase64, true);
      sgReportItemList.Cells[Col, Row] := s;
    end;
  end;

  procedure HandleFileOpen1(Sender: TObject; Text: string);
  begin
    with Sender as TReportComment do
    begin
      if Length(Text) > 50 then
        sgReportItemList.Cells[Col, Row] := Copy(Text, 1, 50) + '...'
      else
        sgReportItemList.Cells[Col, Row] := Text;
    end;
  end;

begin
  sgReportItemList.DefaultRowHeight := 32;
  sgReportItemList.ColCount := 3;
  sgReportItemList.RowCount := Self.Report.ReportItemList.Count + 1;
  sgReportItemList.FixedCols := 0;
  sgReportItemList.FixedRows := 1;
  sgReportItemList.ColWidths[0] := 5;
  sgReportItemList.ColWidths[1] := 140;
  sgReportItemList.ColWidths[2] := 340;
  sgReportItemList.Cells[1, 0] := '<b>Bezeichnung</b>';
  sgReportItemList.Cells[2, 0] := '<b>Inhalt</b>';
  for i := 0 to Self.Report.ReportItemList.Count - 1 do
  begin
    Item := Self.Report.ReportItemList.Items[i];
    sgReportItemList.Cells[1, i + 1] := Item.Bezeichnung;
    case Item.Kind of
      ikUnknown:
        begin
          sgReportItemList.Cells[2, i + 1] := '';
        end;
      ikHeading, ikParagraph:
        begin
          if Item.SubItem <> nil then
            sgReportItemList.Cells[2, i + 1] := Item.SubItem.GetContent;
        end;
      ikComment:
        begin
          with Item.SubItem as TReportComment do
          begin
            Col := 2;
            Row := i + 1;
            OnFileOpen := HandleFileOpen1;
            OpenFile;
          end;
        end;
      ikImage, ikSign:
        begin
          with Item.SubItem as TReportImage do
          begin
            Col := 2;
            Row := i + 1;
            OnFileOpen := HandleFileOpen;
            OpenFile;
          end;
        end;
      ikArtList:
        begin
          sgReportItemList.Cells[2, i + 1] := Item.SubItem.GetContent;
        end;
    end;
  end;
  Self.HandlePropertyChanged(Sender, 'Signed');
end;

procedure TReportForm.sgReportItemListSelectCell(Sender: TObject;
  ACol, ARow: Integer; var CanSelect: Boolean);
begin
  if (0 < ARow) and (ARow <= Self.Report.ReportItemList.Count) then
    Self.Report.ReportItemList.SelectedItem :=
      Self.Report.ReportItemList.Items[ARow - 1]
  else
    Self.Report.ReportItemList.SelectedItem := nil;
end;

procedure TReportForm.tsRepHeadShow(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
end;

procedure TReportForm.tsRepItemsShow(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.sgReportItemListFill(Sender);
end;

procedure TReportForm.tsViewShow(Sender: TObject);
var
  Item: TReportItem;
  i: Integer;
begin
  Self.MainConfig.TimerReset;
  Item := TReportItem.Create;
  Item.Bezeichnung := 'ReportTitel';
  Item.Kind := ikHeading;
  i := Self.Report.ReportItemList.IndexOf(Item);
  if i >= 0 then
    Self.Report.ReportItemList.Delete(i);
  Item := TReportItem.Create;
  Item.Bezeichnung := 'Author';
  Item.Kind := ikHeading;
  i := Self.Report.ReportItemList.IndexOf(Item);
  if i >= 0 then
    Self.Report.ReportItemList.Delete(i);
  Item := TReportItem.Create;
  Item.Bezeichnung := 'Projekt';
  Item.Kind := ikHeading;
  i := Self.Report.ReportItemList.IndexOf(Item);
  if i >= 0 then
    Self.Report.ReportItemList.Delete(i);
  Item := TReportItem.Create;
  Item.Bezeichnung := 'ReportTitel';
  Item.Kind := ikHeading;
  Item.SubItem := TReportHeading.Create;
  with Item.SubItem as TReportHeading do
  begin
    Size := '1';
    Align := 'zentriert';
    Content := 'Bericht vom ' + FormatDateTime('ddd. dd.mm.yyyy',
      Self.Report.Datum);
  end;
  Self.Report.ReportItemList.Insert(0, Item);
  Item := TReportItem.Create;
  Item.Bezeichnung := 'Author';
  Item.Kind := ikHeading;
  Item.SubItem := TReportHeading.Create;
  with Item.SubItem as TReportHeading do
  begin
    Size := '5';
    Align := 'links';
    Content := 'erstellt von ' + Self.Report.User.ToString;
  end;
  Self.Report.ReportItemList.Insert(1, Item);
  Item := TReportItem.Create;
  Item.Bezeichnung := 'Projekt';
  Item.Kind := ikHeading;
  Item.SubItem := TReportHeading.Create;
  with Item.SubItem as TReportHeading do
  begin
    Size := '4';
    Align := 'links';
    Content := 'Auftrag: ' + Self.Report.Fak.ToStringV1;
  end;
  Self.Report.ReportItemList.Insert(2, Item);
  Self.Report.ReportItemList.OnHtmlReady := Self.HandleHtmlReady;
  Self.Report.ReportItemList.CreateHtml;
end;

procedure TReportForm.WebFormCreate(Sender: TObject);
begin
  FMouseDown := false;
  FCreatePdf := false;
end;

procedure TReportForm.WebFormOrientationChange(Sender: TObject;
  AOrientation: TScreenOrientation);
begin
  Self.WebFormResize(Sender);
end;

procedure TReportForm.WebFormResize(Sender: TObject);
var
  t, l: Integer;
begin
  if (Self.Height < 480) or (Self.Width < 640) then
  begin
    btnBack.Width := 24;
    btnBack.Height := 24;
    btnBack.Top := 4;
    btnBack.Left := 4;
    lblHeader.Font.Size := 10;
    lblHeader.Top := 7;
    imgLogo.Width := 74;
    imgLogo.Height := 24;
    imgLogo.Top := 4;
    pnlHeader.Height := 32;
    pnlFooter.Visible := false;
    lblHeader.Caption := 'Bericht';
    pcMain.Top := pnlHeader.Top + pnlHeader.Height;
    pcMain.Height := Self.ClientHeight - pnlHeader.Height;
  end
  else
  begin
    btnBack.Width := 48;
    btnBack.Height := 48;
    btnBack.Top := 8;
    btnBack.Left := 8;
    lblHeader.Font.Size := 16;
    lblHeader.Top := 16;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.Top := 8;
    pnlHeader.Height := 64;
    pnlFooter.Visible := true;
    lblHeader.Caption := 'Winzeit - WebPortal - Bericht';
    pcMain.Top := pnlHeader.Top + pnlHeader.Height;
    pcMain.Height := Self.ClientHeight - pnlHeader.Height - pnlFooter.Height;
  end;
  pnlHeader.Width := Self.ClientWidth;
  pnlFooter.Width := pnlHeader.Width;
  lblHeader.Left := btnBack.Left + btnBack.Width + 8;
  lblHeader.Width := pnlHeader.ClientWidth - imgLogo.Width - 32;
  imgLogo.Left := pnlHeader.ClientWidth - imgLogo.Width - 16;
  pcMain.Width := Min(535, Self.ClientWidth);
  l := (Self.ClientWidth - pcMain.Width) div 2;
  if l < 0 then
    l := 0;
  pcMain.Left := l;
  t := (pcMain.ClientHeight - pnlRepHead.Height) div 2;
  if t < 0 then
    t := 0;
  pnlRepHead.Top := t;
  l := (pcMain.ClientWidth - pnlRepHead.Width) div 2;
  if l < 0 then
    l := 0;
  pnlRepHead.Left := l;
  btnCreatePdf.Left := btnSign.Left;
  btnMail.Left := btnCreatePdf.Left + btnCreatePdf.Width + 4;
end;

procedure TReportForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlHeader := TPanel.Create(Self);
  imgLogo := TImageControl.Create(Self);
  lblHeader := TLabel.Create(Self);
  btnBack := TImageControl.Create(Self);
  pnlFooter := TPanel.Create(Self);
  pcMain := TPageControl.Create(Self);
  tsRepHead := TTabSheet.Create(Self);
  pnlRepHead := TPanel.Create(Self);
  lblAuftrag := TLabel.Create(Self);
  lblAuftrag1 := TLabel.Create(Self);
  lblRepVom := TLabel.Create(Self);
  lblUser := TLabel.Create(Self);
  dtpRepVom := TDateTimePicker.Create(Self);
  tsRepItems := TTabSheet.Create(Self);
  pnlButtons := TPanel.Create(Self);
  btnAppendPicture := TBitBtn.Create(Self);
  btnEdit := TBitBtn.Create(Self);
  btnDelete := TBitBtn.Create(Self);
  btnUp := TBitBtn.Create(Self);
  btnDown := TBitBtn.Create(Self);
  btnAppendNotice := TBitBtn.Create(Self);
  btnAppendMaterial := TBitBtn.Create(Self);
  btnAppendItem := TBitBtn.Create(Self);
  sgReportItemList := TStringGrid.Create(Self);
  tsView := TTabSheet.Create(Self);
  htmlContainer := THTMLContainer.Create(Self);
  pnlSign := TPanel.Create(Self);
  pnlPbButtons := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  btnPbClear := TButton.Create(Self);
  btnPbSign := TButton.Create(Self);
  pbSign := TPaintBox.Create(Self);
  pnlViewButtons := TPanel.Create(Self);
  btnSign := TBitBtn.Create(Self);
  btnCreatePdf := TBitBtn.Create(Self);
  btnMail := TBitBtn.Create(Self);

  pnlHeader.BeforeLoadDFMValues;
  imgLogo.BeforeLoadDFMValues;
  lblHeader.BeforeLoadDFMValues;
  btnBack.BeforeLoadDFMValues;
  pnlFooter.BeforeLoadDFMValues;
  pcMain.BeforeLoadDFMValues;
  tsRepHead.BeforeLoadDFMValues;
  pnlRepHead.BeforeLoadDFMValues;
  lblAuftrag.BeforeLoadDFMValues;
  lblAuftrag1.BeforeLoadDFMValues;
  lblRepVom.BeforeLoadDFMValues;
  lblUser.BeforeLoadDFMValues;
  dtpRepVom.BeforeLoadDFMValues;
  tsRepItems.BeforeLoadDFMValues;
  pnlButtons.BeforeLoadDFMValues;
  btnAppendPicture.BeforeLoadDFMValues;
  btnEdit.BeforeLoadDFMValues;
  btnDelete.BeforeLoadDFMValues;
  btnUp.BeforeLoadDFMValues;
  btnDown.BeforeLoadDFMValues;
  btnAppendNotice.BeforeLoadDFMValues;
  btnAppendMaterial.BeforeLoadDFMValues;
  btnAppendItem.BeforeLoadDFMValues;
  sgReportItemList.BeforeLoadDFMValues;
  tsView.BeforeLoadDFMValues;
  htmlContainer.BeforeLoadDFMValues;
  pnlSign.BeforeLoadDFMValues;
  pnlPbButtons.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  btnPbClear.BeforeLoadDFMValues;
  btnPbSign.BeforeLoadDFMValues;
  pbSign.BeforeLoadDFMValues;
  pnlViewButtons.BeforeLoadDFMValues;
  btnSign.BeforeLoadDFMValues;
  btnCreatePdf.BeforeLoadDFMValues;
  btnMail.BeforeLoadDFMValues;
  try
    Name := 'ReportForm';
    Width := 640;
    Height := 634;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnOrientationChange', 'WebFormOrientationChange');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    pnlHeader.SetParentComponent(Self);
    pnlHeader.Name := 'pnlHeader';
    pnlHeader.Left := 0;
    pnlHeader.Top := 0;
    pnlHeader.Width := 640;
    pnlHeader.Height := 64;
    pnlHeader.Align := alTop;
    pnlHeader.Caption := 'pnlHeader';
    pnlHeader.ChildOrder := 4;
    pnlHeader.Color := clSkyBlue;
    pnlHeader.ShowCaption := False;
    imgLogo.SetParentComponent(pnlHeader);
    imgLogo.Name := 'imgLogo';
    imgLogo.Left := 480;
    imgLogo.Top := 8;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.HeightPercent := 100.000000000000000000;
    imgLogo.WidthPercent := 100.000000000000000000;
    imgLogo.Picture.LoadFromFile('UReportForm.pnlHeader.imgLogo.Picture.png');
    lblHeader.SetParentComponent(pnlHeader);
    lblHeader.Name := 'lblHeader';
    lblHeader.Left := 64;
    lblHeader.Top := 16;
    lblHeader.Width := 410;
    lblHeader.Height := 30;
    lblHeader.Alignment := taCenter;
    lblHeader.AutoSize := False;
    lblHeader.Caption := 'Winzeit - WebPortal - Bericht';
    lblHeader.Font.Charset := DEFAULT_CHARSET;
    lblHeader.Font.Color := clWindowText;
    lblHeader.Font.Height := -21;
    lblHeader.Font.Name := 'Segoe UI';
    lblHeader.Font.Style := [fsBold];
    lblHeader.HeightPercent := 100.000000000000000000;
    lblHeader.ParentFont := False;
    lblHeader.WidthPercent := 100.000000000000000000;
    btnBack.SetParentComponent(pnlHeader);
    btnBack.Name := 'btnBack';
    btnBack.Left := 16;
    btnBack.Top := 16;
    btnBack.Width := 32;
    btnBack.Height := 32;
    btnBack.HeightPercent := 100.000000000000000000;
    btnBack.WidthPercent := 100.000000000000000000;
    btnBack.ChildOrder := 2;
    SetEvent(btnBack, Self, 'OnClick', 'btnBackClick');
    btnBack.Picture.LoadFromFile('UReportForm.pnlHeader.btnBack.Picture.png');
    pnlFooter.SetParentComponent(Self);
    pnlFooter.Name := 'pnlFooter';
    pnlFooter.Left := 0;
    pnlFooter.Top := 610;
    pnlFooter.Width := 640;
    pnlFooter.Height := 24;
    pnlFooter.Align := alBottom;
    pnlFooter.Alignment := taLeftJustify;
    pnlFooter.Caption := 'pnlFooter';
    pnlFooter.ChildOrder := 1;
    pnlFooter.Color := clSkyBlue;
    pcMain.SetParentComponent(Self);
    pcMain.Name := 'pcMain';
    pcMain.Left := 0;
    pcMain.Top := 64;
    pcMain.Width := 640;
    pcMain.Height := 546;
    pcMain.ChildOrder := 2;
    pcMain.TabIndex := 1;
    pcMain.TabOrder := 2;
    tsRepHead.SetParentComponent(pcMain);
    tsRepHead.Name := 'tsRepHead';
    tsRepHead.Left := 0;
    tsRepHead.Top := 20;
    tsRepHead.Width := 640;
    tsRepHead.Height := 526;
    tsRepHead.Caption := 'Berichtskopf';
    SetEvent(tsRepHead, Self, 'OnShow', 'tsRepHeadShow');
    pnlRepHead.SetParentComponent(tsRepHead);
    pnlRepHead.Name := 'pnlRepHead';
    pnlRepHead.Left := 180;
    pnlRepHead.Top := 136;
    pnlRepHead.Width := 350;
    pnlRepHead.Height := 114;
    pnlRepHead.Caption := 'pnlRepHead';
    pnlRepHead.ChildOrder := 5;
    pnlRepHead.ShowCaption := False;
    lblAuftrag.SetParentComponent(pnlRepHead);
    lblAuftrag.Name := 'lblAuftrag';
    lblAuftrag.Left := 8;
    lblAuftrag.Top := 65;
    lblAuftrag.Width := 40;
    lblAuftrag.Height := 15;
    lblAuftrag.Caption := 'Auftrag';
    lblAuftrag.HeightPercent := 100.000000000000000000;
    lblAuftrag.WidthPercent := 100.000000000000000000;
    lblAuftrag1.SetParentComponent(pnlRepHead);
    lblAuftrag1.Name := 'lblAuftrag1';
    lblAuftrag1.Left := 8;
    lblAuftrag1.Top := 80;
    lblAuftrag1.Width := 58;
    lblAuftrag1.Height := 15;
    lblAuftrag1.Caption := 'lblAuftrag1';
    lblAuftrag1.Font.Charset := ANSI_CHARSET;
    lblAuftrag1.Font.Color := clWindowText;
    lblAuftrag1.Font.Height := -12;
    lblAuftrag1.Font.Name := 'Segoe UI Semibold';
    lblAuftrag1.Font.Style := [fsBold];
    lblAuftrag1.HeightPercent := 100.000000000000000000;
    lblAuftrag1.ParentFont := False;
    lblAuftrag1.WidthPercent := 100.000000000000000000;
    lblRepVom.SetParentComponent(pnlRepHead);
    lblRepVom.Name := 'lblRepVom';
    lblRepVom.Left := 8;
    lblRepVom.Top := 12;
    lblRepVom.Width := 64;
    lblRepVom.Height := 15;
    lblRepVom.Caption := 'Bericht vom';
    lblRepVom.HeightPercent := 100.000000000000000000;
    lblRepVom.WidthPercent := 100.000000000000000000;
    lblUser.SetParentComponent(pnlRepHead);
    lblUser.Name := 'lblUser';
    lblUser.Left := 8;
    lblUser.Top := 38;
    lblUser.Width := 58;
    lblUser.Height := 15;
    lblUser.Caption := 'erstellt von';
    lblUser.HeightPercent := 100.000000000000000000;
    lblUser.WidthPercent := 100.000000000000000000;
    dtpRepVom.SetParentComponent(pnlRepHead);
    dtpRepVom.Name := 'dtpRepVom';
    dtpRepVom.Left := 80;
    dtpRepVom.Top := 8;
    dtpRepVom.Width := 100;
    dtpRepVom.Height := 22;
    dtpRepVom.BorderStyle := bsSingle;
    dtpRepVom.ChildOrder := 1;
    dtpRepVom.Color := clWhite;
    dtpRepVom.Date := 46209.454057002320000000;
    dtpRepVom.Role := '';
    dtpRepVom.Text := '';
    SetEvent(dtpRepVom, Self, 'OnChange', 'dtpRepVomChange');
    tsRepItems.SetParentComponent(pcMain);
    tsRepItems.Name := 'tsRepItems';
    tsRepItems.Left := 0;
    tsRepItems.Top := 20;
    tsRepItems.Width := 640;
    tsRepItems.Height := 526;
    tsRepItems.Caption := 'Positionen';
    tsRepItems.ChildOrder := 1;
    SetEvent(tsRepItems, Self, 'OnShow', 'tsRepItemsShow');
    pnlButtons.SetParentComponent(tsRepItems);
    pnlButtons.Name := 'pnlButtons';
    pnlButtons.Left := 0;
    pnlButtons.Top := 0;
    pnlButtons.Width := 640;
    pnlButtons.Height := 48;
    pnlButtons.Align := alTop;
    pnlButtons.Caption := 'pnlButtons';
    pnlButtons.ChildOrder := 2;
    pnlButtons.ShowCaption := False;
    btnAppendPicture.SetParentComponent(pnlButtons);
    btnAppendPicture.Name := 'btnAppendPicture';
    btnAppendPicture.Left := 4;
    btnAppendPicture.Top := 4;
    btnAppendPicture.Width := 40;
    btnAppendPicture.Height := 40;
    btnAppendPicture.Hint := 'Bilder hinzuf'#252'gen';
    btnAppendPicture.Color := clNone;
    btnAppendPicture.Glyph.LoadFromFile('UReportForm.pnlButtons.btnAppendPicture.Glyph.png');
    btnAppendPicture.GlyphSize := 32;
    btnAppendPicture.HeightPercent := 100.000000000000000000;
    btnAppendPicture.ShowHint := True;
    btnAppendPicture.WidthPercent := 100.000000000000000000;
    SetEvent(btnAppendPicture, Self, 'OnClick', 'btnAppendPictureClick');
    btnEdit.SetParentComponent(pnlButtons);
    btnEdit.Name := 'btnEdit';
    btnEdit.Left := 180;
    btnEdit.Top := 4;
    btnEdit.Width := 40;
    btnEdit.Height := 40;
    btnEdit.Hint := 'Eintrag bearbeiten';
    btnEdit.Color := clNone;
    btnEdit.Glyph.LoadFromFile('UReportForm.pnlButtons.btnEdit.Glyph.png');
    btnEdit.GlyphSize := 32;
    btnEdit.HeightPercent := 100.000000000000000000;
    btnEdit.ShowHint := True;
    btnEdit.WidthPercent := 100.000000000000000000;
    SetEvent(btnEdit, Self, 'OnClick', 'btnEditClick');
    btnDelete.SetParentComponent(pnlButtons);
    btnDelete.Name := 'btnDelete';
    btnDelete.Left := 224;
    btnDelete.Top := 4;
    btnDelete.Width := 40;
    btnDelete.Height := 40;
    btnDelete.Hint := 'Position entfernen';
    btnDelete.Color := clNone;
    btnDelete.Glyph.LoadFromFile('UReportForm.pnlButtons.btnDelete.Glyph.png');
    btnDelete.GlyphSize := 32;
    btnDelete.HeightPercent := 100.000000000000000000;
    btnDelete.ShowHint := True;
    btnDelete.WidthPercent := 100.000000000000000000;
    SetEvent(btnDelete, Self, 'OnClick', 'btnDeleteClick');
    btnUp.SetParentComponent(pnlButtons);
    btnUp.Name := 'btnUp';
    btnUp.Left := 268;
    btnUp.Top := 4;
    btnUp.Width := 40;
    btnUp.Height := 40;
    btnUp.Hint := 'Position nach oben';
    btnUp.Color := clNone;
    btnUp.Glyph.LoadFromFile('UReportForm.pnlButtons.btnUp.Glyph.png');
    btnUp.GlyphSize := 32;
    btnUp.HeightPercent := 100.000000000000000000;
    btnUp.ShowHint := True;
    btnUp.WidthPercent := 100.000000000000000000;
    SetEvent(btnUp, Self, 'OnClick', 'btnUpClick');
    btnDown.SetParentComponent(pnlButtons);
    btnDown.Name := 'btnDown';
    btnDown.Left := 312;
    btnDown.Top := 4;
    btnDown.Width := 40;
    btnDown.Height := 40;
    btnDown.Hint := 'Position nach unten';
    btnDown.Color := clNone;
    btnDown.Glyph.LoadFromFile('UReportForm.pnlButtons.btnDown.Glyph.png');
    btnDown.GlyphSize := 32;
    btnDown.HeightPercent := 100.000000000000000000;
    btnDown.ShowHint := True;
    btnDown.WidthPercent := 100.000000000000000000;
    SetEvent(btnDown, Self, 'OnClick', 'btnDownClick');
    btnAppendNotice.SetParentComponent(pnlButtons);
    btnAppendNotice.Name := 'btnAppendNotice';
    btnAppendNotice.Left := 48;
    btnAppendNotice.Top := 4;
    btnAppendNotice.Width := 40;
    btnAppendNotice.Height := 40;
    btnAppendNotice.Hint := 'Notizen hinzuf'#252'gen';
    btnAppendNotice.Color := clNone;
    btnAppendNotice.Glyph.LoadFromFile('UReportForm.pnlButtons.btnAppendNotice.Glyph.png');
    btnAppendNotice.GlyphSize := 32;
    btnAppendNotice.HeightPercent := 100.000000000000000000;
    btnAppendNotice.ShowHint := True;
    btnAppendNotice.WidthPercent := 100.000000000000000000;
    SetEvent(btnAppendNotice, Self, 'OnClick', 'btnAppendNoticeClick');
    btnAppendMaterial.SetParentComponent(pnlButtons);
    btnAppendMaterial.Name := 'btnAppendMaterial';
    btnAppendMaterial.Left := 92;
    btnAppendMaterial.Top := 4;
    btnAppendMaterial.Width := 40;
    btnAppendMaterial.Height := 40;
    btnAppendMaterial.Hint := 'Material hinzuf'#252'gen';
    btnAppendMaterial.Color := clNone;
    btnAppendMaterial.Glyph.LoadFromFile('UReportForm.pnlButtons.btnAppendMaterial.Glyph.png');
    btnAppendMaterial.GlyphSize := 32;
    btnAppendMaterial.HeightPercent := 100.000000000000000000;
    btnAppendMaterial.ShowHint := True;
    btnAppendMaterial.WidthPercent := 100.000000000000000000;
    SetEvent(btnAppendMaterial, Self, 'OnClick', 'btnAppendMaterialClick');
    btnAppendItem.SetParentComponent(pnlButtons);
    btnAppendItem.Name := 'btnAppendItem';
    btnAppendItem.Left := 136;
    btnAppendItem.Top := 4;
    btnAppendItem.Width := 40;
    btnAppendItem.Height := 40;
    btnAppendItem.Hint := 'Eintrag hinzuf'#252'gen';
    btnAppendItem.Color := clNone;
    btnAppendItem.Glyph.LoadFromFile('UReportForm.pnlButtons.btnAppendItem.Glyph.png');
    btnAppendItem.GlyphSize := 32;
    btnAppendItem.HeightPercent := 100.000000000000000000;
    btnAppendItem.ShowHint := True;
    btnAppendItem.WidthPercent := 100.000000000000000000;
    SetEvent(btnAppendItem, Self, 'OnClick', 'btnAppendItemClick');
    sgReportItemList.SetParentComponent(tsRepItems);
    sgReportItemList.Name := 'sgReportItemList';
    sgReportItemList.Left := 0;
    sgReportItemList.Top := 48;
    sgReportItemList.Width := 640;
    sgReportItemList.Height := 478;
    sgReportItemList.Align := alClient;
    sgReportItemList.Options := [goFixedHorzLine,goHorzLine,goRangeSelect,goColSizing,goRowMoving,goRowSelect,goFixedRowDefAlign];
    sgReportItemList.TabOrder := 1;
    SetEvent(sgReportItemList, Self, 'OnDblClick', 'btnEditClick');
    SetEvent(sgReportItemList, Self, 'OnSelectCell', 'sgReportItemListSelectCell');
    sgReportItemList.RangeEdit.Max := 100.000000000000000000;
    sgReportItemList.RangeEdit.Step := 1.000000000000000000;
    sgReportItemList.HeightPercent := 100.000000000000000000;
    sgReportItemList.WidthPercent := 100.000000000000000000;
    tsView.SetParentComponent(pcMain);
    tsView.Name := 'tsView';
    tsView.Left := 0;
    tsView.Top := 20;
    tsView.Width := 640;
    tsView.Height := 526;
    tsView.Caption := 'Ansicht';
    tsView.ChildOrder := 2;
    SetEvent(tsView, Self, 'OnShow', 'tsViewShow');
    htmlContainer.SetParentComponent(tsView);
    htmlContainer.Name := 'htmlContainer';
    htmlContainer.Left := 0;
    htmlContainer.Top := 48;
    htmlContainer.Width := 640;
    htmlContainer.Height := 208;
    htmlContainer.Align := alClient;
    pnlSign.SetParentComponent(tsView);
    pnlSign.Name := 'pnlSign';
    pnlSign.Left := 0;
    pnlSign.Top := 256;
    pnlSign.Width := 640;
    pnlSign.Height := 270;
    pnlSign.Align := alBottom;
    pnlSign.Caption := 'pnlSign';
    pnlSign.ChildOrder := 2;
    pnlSign.ShowCaption := False;
    pnlSign.Visible := False;
    pnlPbButtons.SetParentComponent(pnlSign);
    pnlPbButtons.Name := 'pnlPbButtons';
    pnlPbButtons.Left := 0;
    pnlPbButtons.Top := 0;
    pnlPbButtons.Width := 640;
    pnlPbButtons.Height := 64;
    pnlPbButtons.Align := alTop;
    pnlPbButtons.Caption := 'pnlButtons';
    pnlPbButtons.ShowCaption := False;
    WebLabel1.SetParentComponent(pnlPbButtons);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 8;
    WebLabel1.Top := 41;
    WebLabel1.Width := 104;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'Hier unterschreiben';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    btnPbClear.SetParentComponent(pnlPbButtons);
    btnPbClear.Name := 'btnPbClear';
    btnPbClear.Left := 8;
    btnPbClear.Top := 8;
    btnPbClear.Width := 96;
    btnPbClear.Height := 25;
    btnPbClear.Caption := 'noch mal';
    btnPbClear.ChildOrder := 1;
    btnPbClear.HeightPercent := 100.000000000000000000;
    btnPbClear.WidthPercent := 100.000000000000000000;
    SetEvent(btnPbClear, Self, 'OnClick', 'btnPbClearClick');
    btnPbSign.SetParentComponent(pnlPbButtons);
    btnPbSign.Name := 'btnPbSign';
    btnPbSign.Left := 200;
    btnPbSign.Top := 8;
    btnPbSign.Width := 150;
    btnPbSign.Height := 25;
    btnPbSign.Caption := 'Unterschrift '#252'bernehmen';
    btnPbSign.ChildOrder := 2;
    btnPbSign.HeightPercent := 100.000000000000000000;
    btnPbSign.WidthPercent := 100.000000000000000000;
    SetEvent(btnPbSign, Self, 'OnClick', 'btnPbSignClick');
    pbSign.SetParentComponent(pnlSign);
    pbSign.Name := 'pbSign';
    pbSign.Left := 0;
    pbSign.Top := 64;
    pbSign.Width := 640;
    pbSign.Height := 206;
    pbSign.Align := alClient;
    pbSign.ChildOrder := 1;
    SetEvent(pbSign, Self, 'OnMouseDown', 'pbSignMouseDown');
    SetEvent(pbSign, Self, 'OnMouseLeave', 'pbSignMouseLeave');
    SetEvent(pbSign, Self, 'OnMouseMove', 'pbSignMouseMove');
    SetEvent(pbSign, Self, 'OnMouseUp', 'pbSignMouseUp');
    pnlViewButtons.SetParentComponent(tsView);
    pnlViewButtons.Name := 'pnlViewButtons';
    pnlViewButtons.Left := 0;
    pnlViewButtons.Top := 0;
    pnlViewButtons.Width := 640;
    pnlViewButtons.Height := 48;
    pnlViewButtons.Align := alTop;
    pnlViewButtons.Caption := 'pnlViewButtons';
    pnlViewButtons.ChildOrder := 1;
    pnlViewButtons.ShowCaption := False;
    btnSign.SetParentComponent(pnlViewButtons);
    btnSign.Name := 'btnSign';
    btnSign.Left := 4;
    btnSign.Top := 4;
    btnSign.Width := 40;
    btnSign.Height := 40;
    btnSign.Hint := 'Unterschreiben';
    btnSign.Color := clNone;
    btnSign.Glyph.LoadFromFile('UReportForm.pnlViewButtons.btnSign.Glyph.png');
    btnSign.GlyphSize := 32;
    btnSign.HeightPercent := 100.000000000000000000;
    btnSign.ShowHint := True;
    btnSign.WidthPercent := 100.000000000000000000;
    SetEvent(btnSign, Self, 'OnClick', 'btnSignClick');
    btnCreatePdf.SetParentComponent(pnlViewButtons);
    btnCreatePdf.Name := 'btnCreatePdf';
    btnCreatePdf.Left := 48;
    btnCreatePdf.Top := 4;
    btnCreatePdf.Width := 40;
    btnCreatePdf.Height := 40;
    btnCreatePdf.Hint := 'PDF-Dokument erstellen';
    btnCreatePdf.Color := clNone;
    btnCreatePdf.Glyph.LoadFromFile('UReportForm.pnlViewButtons.btnCreatePdf.Glyph.png');
    btnCreatePdf.GlyphSize := 32;
    btnCreatePdf.HeightPercent := 100.000000000000000000;
    btnCreatePdf.ShowHint := True;
    btnCreatePdf.WidthPercent := 100.000000000000000000;
    SetEvent(btnCreatePdf, Self, 'OnClick', 'btnCreatePdfClick');
    btnMail.SetParentComponent(pnlViewButtons);
    btnMail.Name := 'btnMail';
    btnMail.Left := 92;
    btnMail.Top := 4;
    btnMail.Width := 40;
    btnMail.Height := 40;
    btnMail.Hint := 'Mail-App starten';
    btnMail.Color := clNone;
    btnMail.Glyph.LoadFromFile('UReportForm.pnlViewButtons.btnMail.Glyph.png');
    btnMail.GlyphSize := 32;
    btnMail.HeightPercent := 100.000000000000000000;
    btnMail.ShowHint := True;
    btnMail.WidthPercent := 100.000000000000000000;
    SetEvent(btnMail, Self, 'OnClick', 'btnMailClick');
  finally
    pnlHeader.AfterLoadDFMValues;
    imgLogo.AfterLoadDFMValues;
    lblHeader.AfterLoadDFMValues;
    btnBack.AfterLoadDFMValues;
    pnlFooter.AfterLoadDFMValues;
    pcMain.AfterLoadDFMValues;
    tsRepHead.AfterLoadDFMValues;
    pnlRepHead.AfterLoadDFMValues;
    lblAuftrag.AfterLoadDFMValues;
    lblAuftrag1.AfterLoadDFMValues;
    lblRepVom.AfterLoadDFMValues;
    lblUser.AfterLoadDFMValues;
    dtpRepVom.AfterLoadDFMValues;
    tsRepItems.AfterLoadDFMValues;
    pnlButtons.AfterLoadDFMValues;
    btnAppendPicture.AfterLoadDFMValues;
    btnEdit.AfterLoadDFMValues;
    btnDelete.AfterLoadDFMValues;
    btnUp.AfterLoadDFMValues;
    btnDown.AfterLoadDFMValues;
    btnAppendNotice.AfterLoadDFMValues;
    btnAppendMaterial.AfterLoadDFMValues;
    btnAppendItem.AfterLoadDFMValues;
    sgReportItemList.AfterLoadDFMValues;
    tsView.AfterLoadDFMValues;
    htmlContainer.AfterLoadDFMValues;
    pnlSign.AfterLoadDFMValues;
    pnlPbButtons.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    btnPbClear.AfterLoadDFMValues;
    btnPbSign.AfterLoadDFMValues;
    pbSign.AfterLoadDFMValues;
    pnlViewButtons.AfterLoadDFMValues;
    btnSign.AfterLoadDFMValues;
    btnCreatePdf.AfterLoadDFMValues;
    btnMail.AfterLoadDFMValues;
  end;
end;

end.
